export default __webpack_public_path__ + "static/media/home.9321fcb1.png";